import {Component, Inject, OnInit, Optional} from '@angular/core';
import {MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA, MatLegacySnackBar as MatSnackBar} from '@angular/material/legacy-snack-bar';
import {SnackBarDataInjectedInterface} from 'fuse-core/news/snackbar/snack-bar-data-injected.interface';

@Component({
    selector: 'app-old-learner-start-sub-lessons',
    templateUrl: './old-learner-start-sub-lessons.component.html',
    styleUrls: ['./old-learner-start-sub-lessons.component.scss']
})
export class OldLearnerStartSubLessonsComponent implements OnInit {

    constructor(private snackbar: MatSnackBar,
                @Optional() @Inject(MAT_SNACK_BAR_DATA) public data: SnackBarDataInjectedInterface) {
    }

    onClick() {
        this.snackbar.dismiss();
    }

    ngOnInit(): void {
    }

}
